import React from 'react';
import { FadeIn } from './FadeIn';
export function Tomos() {
  const tomos = [{
    icon: '📋',
    title: 'Tomo 1',
    subtitle: 'Evaluación Nutricional Clínica',
    desc: 'Historia clínica · antropometría · tamizaje'
  }, {
    icon: '💊',
    title: 'Tomo 2',
    subtitle: 'Micronutrientes y Soporte',
    desc: 'Déficits · suplementación · soporte oral'
  }, {
    icon: '🩸',
    title: 'Tomo 3',
    subtitle: 'Síndrome Metabólico',
    desc: 'Insulina · obesidad · dislipidemia'
  }, {
    icon: '🫀',
    title: 'Tomo 4',
    subtitle: 'Patologías Frecuentes',
    desc: 'Digestivas · endocrinas · cardiovasculares'
  }, {
    icon: '⚖️',
    title: 'Tomo 5',
    subtitle: 'Desnutrición Clínica',
    desc: 'Riesgo · intervención · seguimiento'
  }, {
    icon: '📈',
    title: 'Tomo 6',
    subtitle: 'Seguimiento y Evolución',
    desc: 'Adherencia · ajustes · continuidad'
  }];
  return <section className="pt-4 pb-8" data-id="element-290">
      <div className="max-w-4xl mx-auto px-3" data-id="element-291">
        <FadeIn className="text-center mb-5" data-id="element-292">
          <h2 className="font-display text-2xl md:text-4xl font-bold text-white mb-1" data-id="element-293">
            Lo que{' '}
            <span className="bg-clip-text bg-gradient-to-r from-accent to-purple-400 text-[#C9A96E]" data-id="element-294">
              recibís
            </span>
          </h2>
          <p className="text-sm text-white/50 font-medium" data-id="element-295">
            📚 Tu biblioteca clínica práctica — 6 tomos
          </p>
        </FadeIn>

        <FadeIn data-id="element-296">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4" data-id="element-297">
            {tomos.map((tomo, idx) => <div key={idx} className="flex flex-col items-center text-center group" data-id="element-298">
                <div className="w-20 h-26 md:w-24 md:h-32 rounded-[50%] border-[3px] border-accent/40 bg-accent/5 flex flex-col items-center justify-center mb-2 group-hover:border-accent/60 group-hover:bg-accent/10 group-hover:scale-105 transition-all duration-300" data-id="element-299">
                  <span className="text-xl md:text-2xl mb-0.5" data-id="element-300">
                    {tomo.icon}
                  </span>
                  <span className="text-[9px] font-bold text-accent uppercase tracking-wider" data-id="element-301">
                    {tomo.title}
                  </span>
                </div>
                <h4 className="text-xs md:text-sm font-bold text-white mb-0.5 leading-tight" data-id="element-302">
                  {tomo.subtitle}
                </h4>
                <p className="text-[10px] md:text-xs text-white/50 leading-snug" data-id="element-303">
                  {tomo.desc}
                </p>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}